// extracted by mini-css-extract-plugin
export default {"playNow":"SongDetailsLessonPlayAction_playNow__Xm3vW","desktop":"SongDetailsLessonPlayAction_desktop__K13uA"};